<template>
  <div class="star-wrap" :class="isH5 ? 'h5-star-wrap' : 'pc-star-wrap'">
    <div class="stars" v-if="disabled">
      <span
        :class="isDecimal ? 'is-decimal' : ''"
        v-for="item in Math.ceil(score)"
        :key="item"
        class="star-item on"
      ></span>
    </div>
    <div class="stars" v-else>
      <span
        :class="starClass(item)"
        @click="setScore(item)"
        v-for="item in starNum"
        :key="item"
        class="star-item off"
      ></span>
      <span class="description">{{ descriptionText }}</span>
    </div>
  </div>
</template>

<script>
import { isHXApp, isH5 } from "@saas/components";
export default {
  props: {
    score: {
      type: Number,
      default: 0,
    }, //展示的分数
    starNum: {
      type: Number,
      default: 5,
    }, //总分
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      isHXApp: isHXApp(),
      isH5: isH5(),
      result: "", //最终评分
      description: {
        1: "非常差",
        2: "差",
        3: "一般",
        4: "满意",
        5: "非常满意",
      },
    };
  },
  methods: {
    setScore(item) {
      this.result = item;
      this.$emit("result", item);
    },
  },
  computed: {
    descriptionText() {
      if (this.result) {
        return this.description[this.result];
      } else {
        return "";
      }
    },
    isDecimal() {
      if (this.score % 1 === 0) {
        return false;
      } else {
        return true;
      }
    },
    starClass() {
      return function (item) {
        if (!(item > this.result)) {
          return "on";
        } else {
          return "";
        }
      };
    },
  },
  watch: {
    score: {
      handler: function (newVal) {
        if (newVal && !this.disabled) {
          this.result = newVal;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-star-wrap {
  .star-item {
    width: 24px;
    height: 24px;
    margin-right: 2px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
  }
  .description {
    margin-left: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #747573;
    line-height: 22px;
  }
}
.h5-star-wrap {
  .star-item {
    width: 0.64rem;
    height: 0.64rem;
    margin-right: 0.05rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .description {
    margin-left: 0.22rem;
    font-weight: 400;
    font-size: 0.4rem;
    color: #747573;
    line-height: 0.56rem;
  }
}
.star-wrap {
  .stars {
    display: flex;
    align-items: center;
  }
  .star-item.is-decimal:last-child {
    background-image: url("../../../assets/images/star-half.png");
  }
  .star-item.off {
    background-image: url("../../../assets/images/star-off.png");
  }
  .star-item.on {
    background-image: url("../../../assets/images/star-on.png");
  }
  .star-item.half {
    background-image: url("../../../assets/images/star-half.png");
  }
}
</style>
